<template>
  <v-dialog
    :value="value"
    @input="onChange($event)"
  >
    <v-card
      v-if="selectedCategoriesCrumbsClone && value"
      class="outer-container"
    >
      <v-card-title class="bpg-card-title-block g stick-t stripe">
        Assign to a Category
      </v-card-title>

      <div class="product-grid">
        <div class="left-side">
          <ProductCategory
            v-for="cat in categories"
            :key="cat.id"
            :category="cat"
            :selected-categories-map="selectedCategoriesMap"
            @updated="onUpdated($event)"
          />
        </div>

        <div class="divider" />

        <div class="right-side">
          <div
            v-for="cat in selectedCategoriesCrumbsClone"
            :key="cat.category.id"
            class="card"
          >
            <div>
              <div class="font-small">
                {{ cat.crumb }}
              </div>
              <div
                class="font-medium"
                style="font-weight: 600"
              >
                {{ cat.category.categoryName }}
              </div>
            </div>

            <v-btn
              icon
              @click="remove(cat.category.id)"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>
      </div>

      <div class="d-flex bpg-dialog-actions g stick-b">
        <v-btn
          text
          color="primary"
          class="bold-font"
          @click="$emit('input', false)"
        >
          CANCEL
        </v-btn>

        <base-button
          text="ASSIGN"
          variant="text"
          class="mobile ml-auto"
          @click="onAssign()"
        />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import ProductCategory from './product-category.vue'
import * as cloneDeep from 'lodash.clonedeep'

export default {
  name: "ProductCategoriesTreeModal",
  components: { ProductCategory },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    categories: {
      type: Array,
      required: true
    },
    selectedCategoriesCrumbs: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    selectedCategoriesCrumbsClone: []
  }),
  computed: {
    selectedCategoriesMap () {
      if (!this.selectedCategoriesCrumbs) return {}

      const hashMap = {}

      this.selectedCategoriesCrumbsClone.forEach(cat => {
        hashMap[cat.category.id] = true
      })

      return hashMap
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value) {
          this.selectedCategoriesCrumbsClone = cloneDeep(this.selectedCategoriesCrumbs)
        }
      }
    }
  },
  methods: {
    onChange (val) {
      this.$emit("input", val)
    },
    onUpdated (event) {
      console.log(event)
      if (event.isSelected) {
        this.selectedCategoriesCrumbsClone.push({
          category: event.category,
          crumb: event.crumb.slice(0, -2)
        })
      } else {
        this.selectedCategoriesCrumbsClone = this.selectedCategoriesCrumbsClone.filter(x => x.category.id !== event.category.id)
      }
    },
    remove (categoryId) {
      this.selectedCategoriesCrumbsClone = this.selectedCategoriesCrumbsClone.filter(x => x.category.id !== categoryId)
    },
    onAssign () {
      this.$emit('update', this.selectedCategoriesCrumbsClone)
      this.$emit('input', false)
    }
  }

}
</script>

<style lang="scss" scoped>
  @import './src/styles/variables';

.outer-container {
    height: 90vh;
    display: flex;
    flex-direction: column;
}
.g {
    background-color: $even-lighter-grey;
}

.stripe {
    border-bottom: 1px solid $light-grey;
}

.left-side {
    position: relative;
    height: 100%;
    overflow: auto;
    width: 100%;
}

.right-side {
    height: 100%;
    overflow: auto;
    width: 100%;
}

.bold-font {
    font-weight: 600 !important;
}

.card {
    border: 1px solid $light-grey;
    margin: 16px;
    border-radius: 5px;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.stick-t {
    position: sticky;
    top: 0;
    z-index: 2;
}

.stick-b {
    position: sticky;
    bottom: 0;
    z-index: 2;
}

.product-grid {
    display: grid;
    grid-template-columns: 1fr 1px 1fr;
    overflow: auto;
    flex: 1;
    grid-template-rows: 1fr;
}

.divider {
    height: 100%;
    width: 1px;
    background-color: $light-grey;
}
</style>
